<template>
  <component v-bind="$props" :is="collectionPageVersion" />
</template>

<script>
import CollectionPageV2 from "@/views/CollectionV2.vue";

export default {
  name: "CollectionWrapper",
  computed: {
    collectionPageVersion() {
      return CollectionPageV2;
    },
  },
};
</script>
